// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/Users/wbm/dev/KRATOS/kratos_landing/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/Users/wbm/dev/KRATOS/kratos_landing/src/pages/index.js"),
  "component---src-pages-privacy-js": require("gatsby-module-loader?name=component---src-pages-privacy-js!/Users/wbm/dev/KRATOS/kratos_landing/src/pages/privacy.js"),
  "component---src-pages-tos-js": require("gatsby-module-loader?name=component---src-pages-tos-js!/Users/wbm/dev/KRATOS/kratos_landing/src/pages/tos.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/wbm/dev/KRATOS/kratos_landing/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/Users/wbm/dev/KRATOS/kratos_landing/.cache/json/404.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/wbm/dev/KRATOS/kratos_landing/.cache/json/layout-index.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/Users/wbm/dev/KRATOS/kratos_landing/.cache/json/index.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/wbm/dev/KRATOS/kratos_landing/.cache/json/layout-index.json"),
  "privacy.json": require("gatsby-module-loader?name=path---privacy!/Users/wbm/dev/KRATOS/kratos_landing/.cache/json/privacy.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/wbm/dev/KRATOS/kratos_landing/.cache/json/layout-index.json"),
  "tos.json": require("gatsby-module-loader?name=path---tos!/Users/wbm/dev/KRATOS/kratos_landing/.cache/json/tos.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/wbm/dev/KRATOS/kratos_landing/.cache/json/layout-index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/Users/wbm/dev/KRATOS/kratos_landing/.cache/json/404-html.json")
}

exports.layouts = {
  "component---src-layouts-index-js": require("gatsby-module-loader?name=component---src-layouts-index-js!/Users/wbm/dev/KRATOS/kratos_landing/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js